import React, { useCallback, useState } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

function BranchSelectorDialog (props) {
  const { value, reportSubmissionId, existingCodes, onAction } = props
  const [dialogValue, setDialogValue] = useState(value)

  const onChange = useCallback(({ value }) => { setDialogValue(value) }, [setDialogValue])
  const dataSource = useCallback((request, options) =>
    context.api.userRowHeaderService.getLookupBranches(reportSubmissionId, existingCodes, request, options), [existingCodes, reportSubmissionId])
  const onActionCallback = useCallback(() => onAction(dialogValue), [onAction, dialogValue])
  const renderFooter = ({ isValid }) =>
    <ConfirmFooter primaryButtonText='Common.SaveAndClose'
      icon='save'
      disabled={!isValid}
      {...props}
      onAction={onActionCallback} />

  return <ValidationBoundary>
    <BasicHeader title='Common.SelectBranch' {...props} />
    <ModalBody>
      <Validator name='value' value={dialogValue} required>
        <DropDownList
          dataSource={dataSource}
          value={dialogValue}
          onChange={onChange} />
      </Validator>
    </ModalBody>
    <ValidationState render={renderFooter} />
  </ValidationBoundary>
}

export default {
  component: BranchSelectorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/branchSelector.js